import React from 'react';

import Button from '~/core/atoms/Buttons/Button';
import CloseIcon from '~/core/iconComponents/icons/CloseIcon';
import cn from '~/utils/cn';

interface SidePanelProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
  onClose: () => void;
  className?: string;
}

export const SidePanel: React.FC<SidePanelProps> = ({ icon, title, content, footer, onClose, className }) => {
  return (
    <div
      className={cn(
        '__SIDE_PANEL__ flex h-full w-full flex-col gap-12 rounded-l-xl rounded-br-xl bg-white p-24 shadow-xl',
        className
      )}
    >
      <div className="__SIDE_PANEL_HEADER__ flex items-center justify-between gap-12 p-4">
        <div className="flex items-start gap-12">
          <div className="flex flex-1 items-center justify-center">{icon}</div>
          <div className="flex min-h-32 items-center text-lg font-semibold">{title}</div>
        </div>
        <Button
          onClick={onClose}
          className="hover:bg-bluesky-100 m-0 rounded-full bg-transparent p-0 p-4 text-slate-900 transition-colors"
          aria-label="Close panel"
          size="sm"
        >
          <CloseIcon size={20} className="m-0 cursor-pointer" />
        </Button>
      </div>
      <div className="__SIDE_PANEL_CONTENT__ flex-1 overflow-auto">{content}</div>

      <div className="__SIDE_PANEL_FOOTER__ mt-auto">{footer}</div>
    </div>
  );
};

export default SidePanel;
